import React from "react";
import {
  Bullseye,
  Gear,
  CheckCircle,
  Mortarboard,
  PlayCircle,
  ArrowRepeat,
} from "react-bootstrap-icons";

const steps = [
  {
    step: 1,
    title: "Align",
    description: "Understand goals and priorities",
    icon: <Bullseye />,
  },
  {
    step: 2,
    title: "Configure",
    description: "Apply proven best practices",
    icon: <Gear />,
  },
  {
    step: 3,
    title: "Validate",
    description: "Test and confirm accuracy",
    icon: <CheckCircle />,
  },
  {
    step: 4,
    title: "Enable",
    description: "Train users",
    icon: <Mortarboard />,
  },
  {
    step: 5,
    title: "Launch",
    description: "Go-live with confidence",
    icon: <PlayCircle />,
  },
  {
    step: 6,
    title: "Evolve",
    description: "Optimize and scale",
    icon: <ArrowRepeat />,
  },
];

export default function VelocityDeliveryCycle() {
  return (
    <section className="py-5 text-center">
      <div className="container">
        <h2 className="fw-bold mb-2">The Velocity Delivery Cycle</h2>
        <p className="text-muted mb-5">
          A proven six-phase approach that ensures successful deployments
        </p>

        <div className="row g-4 justify-content-center">
          {steps.map((step, i) => (
            <div key={i} className="col-6 col-md-4 col-lg-2">
              <div className="velocity-card h-100">
                <div className="step-number">{step.step}</div>
                <div className="icon-circle">{step.icon}</div>
                <h6 className="fw-bold mt-3">{step.title}</h6>
                <p className="small text-muted mb-0">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
